// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRewritesTunnelPath"] = undefined;globalThis["SENTRY_RELEASE"] = {"id":"DhkL2RHGtw01LIm17I3qD"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";import { AxiosError } from 'axios';
import * as Sentry from '@sentry/nextjs';

if (process.env.NEXT_PUBLIC_BACKOFFICE_ENV === 'production') {
  Sentry.init({
    dsn: 'https://ac899d74def0490d7ccc734c6d154818@o4506479318859776.ingest.us.sentry.io/4506916199858176',

    // Adjust this value in production, or use tracesSampler for greater control
    tracesSampleRate: 0.5,

    // Setting this option to true will print useful information to the console while you're setting up Sentry.
    debug: false,

    replaysOnErrorSampleRate: 1.0,

    // This sets the sample rate to be 10%. You may want this to be 100% while
    // in development and sample at a lower rate in production
    replaysSessionSampleRate: 0.1,

    // You can remove this option if you're not planning to use the Sentry Session Replay feature:
    integrations: [
      Sentry.replayIntegration({
        // Additional Replay configuration goes in here, for example:
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
    beforeSend(event, hint) {
      const response = hint.originalException as AxiosError;
      if (
        response?.message === 'Request failed with status code 403' ||
        response?.message === 'Network Error'
      ) {
        return null;
      }

      const error = hint?.originalException as Error;
      if (error?.message?.includes('Minified React error')) {
        console.error('React error captured:', error);
      }

      return event;
    },
    release: process.env.SENTRY_RELEASE,
    environment: process.env.NEXT_PUBLIC_BACKOFFICE_ENV,
  });
}
